<template>
  <div
    :class="[
      namespace,
      dir,
    ]"
    :style="[
      gap ? `--steps-gap: ${gap}` : '',
      itemPadding ? `--steps-item-padding: ${itemPadding}` : '',
    ]"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, watch, provide, getCurrentInstance } from 'vue'
import { useNamespace, useOrderedChildren } from '@hongluan-ui/hooks'
import { CHANGE_EVENT } from '@hongluan-ui/constants'
import { stepsEmits, stepsProps } from './steps'

import type { StepItemState } from './item.vue'

export default defineComponent({
  name: 'Steps',
  props: stepsProps,
  emits: stepsEmits,
  setup(props, { emit }) {
    const { namespace } = useNamespace('steps')
    const {
      children: steps,
      addChild: addStep,
      removeChild: removeStep,
    } = useOrderedChildren<StepItemState>(getCurrentInstance()!, 'Step')

    watch(steps, () => {
      steps.value.forEach((instance, index) => {
        instance.setIndex(index)
      })
    })

    provide('Steps', { props, steps, addStep, removeStep })

    watch(() => props.active, (newVal, oldVal) => {
      emit(CHANGE_EVENT, newVal, oldVal)
    })

    return {
      namespace,
      steps,
    }
  },
})
</script>
